import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../../redux/store'

// Define the initial state using that type
const initialState = (): NavigationState => {
    const getParam = (params, paramName, initialValue) => {
        const aux = params.get(paramName)
        return aux ? decodeURIComponent(aux) : initialValue
    }

    let filter = {
        project: [],
        site: [],
        well: [],
        wellbore: [],
        event: [],
        rig: [],
        section: [],
        label: [""],
        active: [false]
    }

    const hash = document.location.hash
    const params = new URLSearchParams(document.location.hash.slice(hash.indexOf('?') + 1));
    if (params && params.get('tree_filters')) {
        const extratedFilters = decodeURIComponent(params.get('tree_filters'))
            .split('&')
            .reduce((accumulator, value) => {
                const decodedValue = decodeURIComponent(value)
                const key = decodedValue.slice(5, decodedValue.indexOf("=")) 
                const array = decodedValue.slice(decodedValue.indexOf("=")+1).split(',').filter(v => v !== "")

                if (key === "active") {
                    //@ts-ignore
                    array.splice(0, 1, /^true$/i.test(array[0])) 
                }

                return {
                    ...accumulator, 
                    [key]: array 
                }
            }, {})

        //@ts-ignore
        filter = extratedFilters;
    }

    let selectedTreeNode = "";
    let selectedDashboardId = 1;
    let dashboardMode = "view"
    if (params) {
        selectedTreeNode = getParam(params, 'tree_selectednode', "")
        selectedDashboardId = Number.parseInt(getParam(params, 'tree_selecteddashboard', 1))
        dashboardMode = getParam(params, 'mode', "view")    
    }

    let open = true
    if (localStorage.getItem(`user/${window.Live.currentUser.id}/adnocSidebarState`) == "false") {
        open = false
    }

    return {
        filter,
        selectedDashboard: undefined,
        selectedDashboardNode: undefined,
        path: [],
        open,
        selectedTreeNode,
        selectedDashboardId,
        mobileDashboardTab: 0,
        loading: false,
        dashboardMode,
        navigationLoading: false,
        activeOnly: filter.active[0]
    }
}

export const navigationSlice = createSlice({
  name: 'navigation',
  initialState: initialState(),
  reducers: {
    setFilters: (state, action: PayloadAction<NavigationFilters>) => {
        state.filter = action.payload
    },
    setSelectedDashboard: (state, action: PayloadAction<Dashboard>) => {
        state.selectedDashboard = action.payload
    },
    setSelectedDashboardNode: (state, action: PayloadAction<DashboardNode>) => {
        state.selectedDashboardNode = action.payload
    },
    setPath: (state, action: PayloadAction<DashboardNode[]>) => {
        state.path = action.payload
    },
    setOpen: (state, action: PayloadAction<boolean>) => {
        state.open = action.payload
    },
    setSelectedTreeNode: (state, action: PayloadAction<string>) => {
        state.selectedTreeNode = action.payload
    },
    setSelectedDashboardId: (state, action: PayloadAction<number>) => {
        state.selectedDashboardId = action.payload
    },
    setMobileDashboardTab: (state, action: PayloadAction<number>) => {
        state.mobileDashboardTab = action.payload
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
        state.loading = action.payload
    },
    setDashboardMode: (state, action: PayloadAction<string>) => {
        state.dashboardMode = action.payload
    },
    setNavigationLoading: (state, action: PayloadAction<boolean>) => {
        state.navigationLoading = action.payload
    },
    setActiveOnly: (state, action: PayloadAction<boolean>) => {
        state.activeOnly = action.payload
    },
  },
})

export const { 
    setFilters, 
    setSelectedDashboard, 
    setSelectedDashboardNode, 
    setPath, 
    setOpen, 
    setSelectedTreeNode, 
    setSelectedDashboardId,
    setMobileDashboardTab,
    setLoading,
    setDashboardMode,
    setNavigationLoading,
    setActiveOnly
} = navigationSlice.actions

export const selectFilter = (state: RootState) => state.navigation.filter
export const selectSelectedDashboard = (state: RootState) => state.navigation.selectedDashboard
export const selectSelectedDashboardNode = (state: RootState) => state.navigation.selectedDashboardNode
export const selectPath = (state: RootState) => state.navigation.path
export const selectOpen = (state: RootState) => state.navigation.open
export const selectSelectedTreeNode = (state: RootState) => state.navigation.selectedTreeNode
export const selectSelectedDashboardId = (state: RootState) => state.navigation.selectedDashboardId
export const selectMobileDashboardTab = (state: RootState) => state.navigation.mobileDashboardTab
export const selectLoading = (state: RootState) => state.navigation.loading
export const selectDashboardMode = (state: RootState) => state.navigation.dashboardMode
export const selectNavigationLoading = (state: RootState) => state.navigation.navigationLoading
export const selectActiveOnly = (state: RootState) => state.navigation.activeOnly

export default navigationSlice.reducer